/**
 * 채점 결과 관련 API 서비스
 * 페이지별 채점 결과 조회
 */

import axiosInstance from '../config/axios';
import { PageResult } from '../types/result';

/**
 * 페이지 채점 결과 조회
 *
 * GET /api/v1/student/workbooks/{workbook_name}/page/{page}/result
 *
 * @param workbookName - 문제집명
 * @param page - 페이지 번호
 * @returns 페이지 채점 결과 (통계 + 문제별 결과)
 */
export const getPageResult = async (
  workbookName: string,
  page: number
): Promise<PageResult> => {
  try {
    const response = await axiosInstance.get(
      `/student/workbooks/${encodeURIComponent(workbookName)}/page/${page}/result`
    );
    return response.data;
  } catch (error: any) {
    // 404는 정상 케이스 (제출 없음) - 에러 로그 출력 안 함
    if (error.response?.status !== 404) {
      console.error('Failed to fetch page result:', error);
    }
    throw error;
  }
};
